module.exports = __webpack_public_path__ + "static/media/012.d9959fd6.jpg";